module.exports = __webpack_public_path__ + "img/albert.24447af3.jpeg";